import { CredentialType } from '@uac-au/advance-typings';
import { RequiredCredential } from 'types/required-credential';
import { SourceInstitution } from 'types/source-institution';

/**
 * Groups Source Institutions by country and sorts by name.
 * @export
 * @param {SourceInstitution[]} sourceInstitutions
 * @return {*}  {Map<string, SourceInstitution[]>}
 */
export function groupByCountry(sourceInstitutions: SourceInstitution[]): Map<string, SourceInstitution[]> {
  const institutionMap = sourceInstitutions.reduce<Map<string, SourceInstitution[]>>((map, institution) => {
    const key = institution.country;
    const exists = map.get(key);
    if (exists) {
      exists.push(institution);
    } else {
      map.set(key, [institution]);
    }
    return map;
  }, new Map());
  institutionMap.forEach((list) => list.sort((a, b) => a.country.toLowerCase().localeCompare(b.country.toLowerCase())));
  return institutionMap;
}

/**
 * Derive a Source Credential object from a Required Credential.
 * @export
 * @param {RequiredCredential} requiredCredential
 * @return {*}  {(SourceInstitution | undefined)}
 */
export function getSourceInstitution(requiredCredential: RequiredCredential): SourceInstitution | undefined {
  let ID: string | undefined;
  let country: string | undefined;
  let name: string | undefined;
  switch (requiredCredential.type) {
    case CredentialType.EMPLOYMENT:
      ID = requiredCredential.matchingCriteria.find((match) => match.field === 'company')?.value;
      country = requiredCredential.matchingCriteria.find((match) => match.field === 'country')?.value;
      name = requiredCredential.matchingCriteria.find((match) => match.field === 'company')?.value;
      break;
    default: {
      // @ts-expect-error: typing issue with credential.type union type
      ID = requiredCredential.matchingCriteria.find((match) => match.field === 'institutionCode')?.value;
      // @ts-expect-error: typing issue with credential.type union type
      country = requiredCredential.matchingCriteria.find((match) => match.field === 'country')?.value;
      // @ts-expect-error: typing issue with credential.type union type
      name = requiredCredential.matchingCriteria.find((match) => match.field === 'institutionName')?.value ?? ID;
      break;
    }
  }
  if (!ID || !country || !name) {
    return undefined;
  }
  return { ID, country, name };
}

/**
 * Sorts Source Institutions by name (asc) > country (asc).
 * Does not mutate input array, returns a new array.
 * @export
 * @param {SourceInstitution[]} sourceInsitutions
 * @return {*}  {SourceInstitution[]}
 */
export function sortInitialSourceInsitutions(sourceInsitutions: SourceInstitution[]): SourceInstitution[] {
  return [...sourceInsitutions].sort((a, b) => {
    if (a.name.toLowerCase() === b.name.toLowerCase()) {
      return a.country.toLowerCase().localeCompare(b.country.toLowerCase());
    }
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  });
}
